// Maps a streamed tool part type to the message shown in the typing indicator
// while that tool is running (e.g. "Looking up faculty…").
//
// Tool parts arrive from the agent over the Vercel AI SDK UI message stream as
// `tool-<ToolName>`, moving through states input-streaming → input-available →
// output-available. The indicator shows a tool's message only while it is still
// running (before output-available); see ToolActivityIndicator.
//
// To add a message for a new tool, add an entry keyed by its `tool-<ToolName>`
// type. Unmapped tools fall back to DEFAULT_TOOL_ACTIVITY_MESSAGE.
export const TOOL_ACTIVITY_MESSAGES = {
    "tool-SemanticSearchTool": "Searching the agenda…",
    "tool-FindSessionsByDateTool": "Checking the schedule…",
    "tool-FindSessionsByTopicTool": "Searching sessions by topic…",
    "tool-FindFacultyByNameTool": "Looking up faculty…",
    "tool-GetSessionDetailsTool": "Pulling up session details…",
    "tool-GetVenueInfoTool": "Looking up venue info…",
    "tool-GetConferenceInfoTool": "Checking conference info…",
    "tool-GetConferenceOverviewTool": "Getting the conference overview…",
    "tool-RecommendSessionsTool": "Picking sessions for you…",
    "tool-FindSlidesTool": "Finding slide decks…",
    "tool-GetSlideDeckSummaryTool": "Reading the slides…",
}
export const DEFAULT_TOOL_ACTIVITY_MESSAGE = "Working on it…"

// The backend explains an extra wait with a status line, sent as this tool part —
// e.g. "I didn't find “Jane Doe” in the agenda — checking the conference website…"
// when an agenda lookup comes up empty and falls back to the website. See
// docs/ai-chat-status-updates.md in crf-agenda for the contract.
export const STATUS_TOOL_TYPE = "tool-StatusUpdate"

// A website lookup that follows an earlier lookup in the same turn is the agent
// digging further (e.g. a keynote speaker's page after finding them in the
// program), so say so instead of the generic label.
export const FOLLOW_UP_WEBSITE_MESSAGE = "Checking the conference website for more…"

// A field of a StatusUpdate part: input first (it arrives before the output), then
// the output's JSON string. `message` is shown while the agent works; `note` is the
// past-tense line kept above the finished answer.
function statusField(part, field) {
    if (part?.input?.[field]) return part.input[field]
    if (typeof part?.output !== "string") return part?.output?.[field] || null
    try {
        return JSON.parse(part.output)[field] || null
    } catch {
        return null
    }
}

export const statusMessage = part => statusField(part, "message")

export const statusNote = part => statusField(part, "note") || statusMessage(part)
